import {
    inject,
    Injectable,
    PLATFORM_ID,
    REQUEST_CONTEXT,
} from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    DefaultUrlSerializer,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';

import { Observable, Subject } from 'rxjs';

import { Config } from '../../shared/config';
import { ContentService } from '../content/content.service';

import { isCurrentPageInPagesOrProductsComponent } from '@src/app/shared/utils/utils';
import { RedirectsService } from '../services/redirect.service';

import { WINDOW } from '../models/tokens';
import { RequestContext } from '../utils/models';
import { isPlatformServer } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class PageGuard implements CanActivate, CanActivateChild {
    urlSerializer = new DefaultUrlSerializer();

    viewPage$: Subject<boolean> = new Subject();

    redirectService = inject(RedirectsService);
    router = inject(Router);
    platformId = inject(PLATFORM_ID);
    window = inject(WINDOW);

    context: RequestContext = inject(REQUEST_CONTEXT) as RequestContext;
    constructor(
        private contentService: ContentService,
        private config: Config,
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        if (isPlatformServer(this.platformId)) {
            return true;
        }

        const pageMatches: boolean = isCurrentPageInPagesOrProductsComponent(
            this.contentService.pagesData,
            route.url,
            this.config.getCurrentLanguage(),
        );

        if (pageMatches) {
            return true;
        } else {
            return this.redirectService.browserRedirect(state.url) ?? false;
        }
    }

    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ):
        | boolean
        | UrlTree
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree> {
        return this.canActivate(childRoute, state);
    }
}
